import React from "react"
import { withFormController } from "../../Molecules/FormController"
import { Checkbox, Intent, CheckboxProps } from "@blueprintjs/core"
import classNames from "utils/classNames"
import styles from "./styles.module.css"
interface CustomCheckboxProps extends CheckboxProps {
  /**
   * Allows the end user to change the color of the checkbox (not natively supported by Blueprintjs. is a custom feature)
   */
  intent: Intent
  value: any
  data?: any
  onChange?: any
  error?: any
  path?: any
  source?: any
  onAdd?: any
  onRemove?: any
  rounded?: boolean
  white?: boolean
}
const CustomCheckbox = ({
  value,
  data,
  onChange,
  error,
  path,
  source,
  onAdd,
  onRemove,
  intent,
  className,
  rounded = false,
  white = false,
  ...OtherProps
}: CustomCheckboxProps) => {
  let boolValue: any
  if (typeof value === "string") {
    const str = value.toLowerCase()
    if (str === "true") {
      boolValue = true
    } else if (str === "false") {
      boolValue = false
    } else {
      boolValue = value ? true : false
    }
  } else {
    boolValue = value ? true : false
  }

  const handleChange = () => {
    if (data) {
      onChange(path, boolValue ? null : data)
    } else {
      onChange(path, !boolValue)
    }
  }

  return (
    <Checkbox
      checked={boolValue}
      onChange={handleChange}
      {...OtherProps}
      className={classNames(
        styles["base"],
        rounded && styles["rounded"],
        white && styles["white"],
        intent && styles[intent],
        className
      )}
    />
  )
}

export default withFormController(CustomCheckbox)
